var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 13.2H5.4c-.675 0-1.2-.525-1.2-1.2 0-.637.525-1.2 1.2-1.2h13.2c.637 0 1.2.563 1.2 1.2 0 .675-.563 1.2-1.2 1.2z",
    fill: "currentColor"
  })));
}
export default SvgMinusIcon;